// Одноразовая уборка ЛЕГАСИ-хранилищ старых архитектур WalletConnect.
//
// Импортируется в index.js первой строкой (side-effect до любых
// `import '@walletconnect/*'`).
//
// ⚠️ С 31.08 сессии живут в СТАНДАРТНОМ хранилище единственного SignClient
// (ключи `wc@2:*` в localStorage) и ДОЛЖНЫ переживать перезагрузку вебвью —
// их здесь НЕ трогаем (раньше этот файл стирал wc@*, при новой схеме это
// убивало бы сессии на каждом старте). Чистим только:
//  - `wc_kv:*` — неймспейсы старой мультипровайдерной схемы;
//  - `wcm_*` / w3m — остатки выпиленной модалки.
// От протухших сессий защищают: проверка expiry в getSessionRecord,
// пинг перед транзакциями и walletConnectErrorGuard.

(function cleanupLegacy() {
    try {
        if (typeof localStorage === 'undefined') return;
        const kill = [];
        for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i);
            if (!k) continue;
            const lower = k.toLowerCase();
            if (k.startsWith('wc_kv:') || lower.includes('wcm_') || lower.includes('w3m')) {
                kill.push(k);
            }
        }
        kill.forEach((k) => { try { localStorage.removeItem(k); } catch {} });
    } catch {}
})();

export {};
